import { CmsBuildStepperWidget } from './types';

export default {
  primaryFinishAltCtaText: 'Deploy',
  primaryFinishCtaText: 'Build & Deploy',
  secondaryFinishCtaText: 'Only Build',
  nameYourBuildStep: {
    heading: 'Name Your Project',
    subheading: '',
    nameYourBuild: {
      labelText: 'Name Your Project',
      placeholderText: 'Enter a project name',
      tooltipText:
        'A collection of app files, Mason OS configurations, and other media that is used to create builds for a specific Mason device type. Builds can be deployed to device groups. Read more here → [Build and Deploy using Controller](https://docs.bymason.com/setup-guide#build-and-deploy-your-project-using-controller)',
    },
    description: {
      labelText: 'Description',
      placeholderText: 'What is the purpose of this project and its builds?',
      tooltipText: '',
    },
    apiLevel: {
      labelText: 'API Level',
      placeholderText: 'Select API Level',
      tooltipText:
        'API level corresponds to the version of Android running on your Mason device — level 25 for Android 7 and level 30 for Android 11. Learn more here → [Build and Deploy using Controller](https://docs.bymason.com/setup-guide#build-and-deploy-your-project-using-controller)',
    },
  },
  apkStep: {
    altHeading: 'Choose Application Packages',
    heading: 'Upload Application Packages',
    subheading: '',
    uploadApk: {
      altLabelText: 'Select or Upload APKs',
      altPlaceholderText: 'Select existing APK...',
      labelText: 'Upload APKs',
      helperText: 'The .apk files are packaged mobile applications that will be installed on your device.',
      placeholderText: '.apk file type',
      tooltipText:
        'This is your Android Package file containing your app. You can have multiple APKs in your project. Read more here → [Build and Deploy using Controller](https://docs.bymason.com/setup-guide#build-and-deploy-your-project-using-controller)',
      ctaText: 'New',
    },
  },
  assetsStep: {
    altHeading: 'Choose Application Assets',
    heading: 'Upload Application Assets',
    subheading: '',
    uploadBootAnimation: {
      altLabelText: 'Select or Upload Boot Animation',
      altPlaceholderText: 'Select existing boot animation...',
      labelText: 'Upload Boot Animation',
      helperText:
        'Add your company branding to your Mason device with an animation that loops as the device is starting up.',
      placeholderText: '.zip file type',
      tooltipText:
        'A boot animation is the loop that shows while the device is booting-up. Read more here → [Build and Deploy using Controller](https://docs.bymason.com/setup-guide#build-and-deploy-your-project-using-controller)',
      ctaText: 'New',
    },
    uploadSplashScreen: {
      altLabelText: 'Select or Upload Splash Screen',
      altPlaceholderText: 'Select existing splash screen...',
      labelText: 'Upload Splash Screen',
      helperText:
        'Add your company branding to your Mason device with a static image that displays as soon as the device is turned on.',
      placeholderText: '.png file type',
      tooltipText:
        'The image needs to be in PNG format and we recommend a square image with dimensions of 1080x1080 pixels. Read more here → [Build and Deploy using Controller](https://docs.bymason.com/setup-guide#build-and-deploy-your-project-using-controller)',
      ctaText: 'New',
    },
  },
  osBehaviorStep: {
    heading: 'How do you want the device OS to behave?',
    subheading:
      'An OS configuration (.yaml) file describes the behavior of the device system software, OS features, apps, settings, etc.',
    uploadConfig: {
      labelText: 'Upload Yaml Configuration File',
      helperText: '',
      placeholderText: '.yaml file type',
      tooltipText:
        'Your .yaml file should reference the build name, and the names of the apps and media files you wish to deploy. Read more here → [Build and Deploy using Controller](https://docs.bymason.com/setup-guide#build-and-deploy-your-project-using-controller)',
      ctaText: 'New',
    },
  },
  reviewStep: {
    heading: 'Review & Edit',
    subheading:
      'Review the information you provided and fix any validation errors prior to building. You may edit the configuration yaml file to fine tune OS behavior.',
    deployBuildTo: {
      altLabelText: '',
      labelText: 'Deploy Your Build To',
      helperText: '',
      placeholderText: 'Add or choose a deployment group',
      altPlaceholderText: 'Enter a deployment group name',
      tooltipText:
        'Deployment groups provide a way to logically organize your devices however you like so that you can over-the-air (OTA) deploy builds of your choosing to those devices. Read more here → [Build and Deploy using Controller](https://docs.bymason.com/setup-guide#build-and-deploy-your-project-using-controller)',
    },
    nameLabel: 'Name',
    apiLevelLabel: 'API Level',
    apkLabel: 'APKs',
    bootAnimationLabel: 'Boot Animation',
    splashScreenLabel: 'Splash Screen',
    osBehaviorLabel: 'OS Configuration',
    creatingBuildLabel: 'Build',
    deployingBuildLabel: 'Deploy to',
    sampleAppApkName: 'iHeartLives Sample',
    sampleAppBootAnimationName: 'iHeartLives Sample',
    sampleAppSplashScreenName: 'iHeartLives Sample',
    sampleAppOsConfigurationName: 'iHeartLives Sample',
  },
} as CmsBuildStepperWidget;
